import React, { useState } from "react";
import { get } from "lodash";
import { useSelector } from "react-redux";

import { getIcon } from "../../helpers/icons";
import { isSaved } from "../../helpers/media";
import { showToast } from "../../helpers/notify";
import AsyncGet from "../AsyncGet";
import Button from "../Field/Button";

import style from "./style.module.css";

export default function ArticleSave({ id }) {
    const userProfile = useSelector((state) => state.storage.data);
    const isSavedCheck = isSaved(id, userProfile.savedList);
    const [saveCheck, setSaveCheck] = useState(isSavedCheck)

    const hoddleAlert = (data) => {
        if (get(data, "id") !== "") {
            showToast(saveCheck ? data.message !== undefined ? data.message : "Article removed" : data.message !== undefined ? data.message : "Article saved");
        }
    }

    if (userProfile.id !== undefined) {
        return (
            <AsyncGet
                url={`/account/article/${id}`}
                method={saveCheck ? "delete" : "post"}
                permissionText={saveCheck ? "Delete Article" : "Save Article"}
                onFetch={({ data }) => {
                    hoddleAlert(data);
                    if (data.id) {
                        setSaveCheck(true)
                    }
                    else {
                        setSaveCheck(false)
                    }
                }}
                render={({ fetching, loadFromAPI }) => {
                    return (
                        <Button
                            className={style.saveBtn}
                            onClick={loadFromAPI}
                            fetching={fetching}
                            color="buttonSecondary"
                            icon={<i className={getIcon(saveCheck ? "Check" : "Circle")}></i>}
                            label={saveCheck ? "Saved" : "Save"}
                        />
                    )
                }}
            />
        )
    } else {
        return (
            <Button
                link={`/sign-in?redirect=${window.location.pathname}`}
                className={style.saveBtn}
                color="buttonSecondary"
                icon={<i className={getIcon("Circle")}></i>}
                label={"Save"}
            />
        );
    }
}